import { render, staticRenderFns } from "./MutilateBarChart.vue?vue&type=template&id=31c605c4"
import script from "./MutilateBarChart.vue?vue&type=script&lang=js"
export * from "./MutilateBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports